export default {
  // 获取投票详细接口
  ballotDetailed: '/member/anonymous/amc/ballotDetailed',
  // 提交投票
  addBallotData: '/member/anonymous/amc/addBallotData'
}